import axios from "axios"
import store from "@/store"
import { AccountService } from "@/services"
import { isArray, isPlainObject, join, isString } from "lodash"

const HMD_BACKEND_API_URL =
  process.env.VUE_APP_ROOT_API || "http://localhost:8002/api"
const HTTP = axios.create({
  baseURL: HMD_BACKEND_API_URL,
  timeout: 180000
})

HTTP.interceptors.request.use(
  config => {
    store.commit("loading-request-start")
    if (store.state.user?.key != null) {
      config.headers.authorization = "Token " + store.state.user?.key
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
HTTP.interceptors.response.use(
  config => config,
  error => {
    store.commit("loading-request-end")
    const res = error.response
    if (res) if (res.status === 401) AccountService.logout()
    return Promise.reject(error)
  }
)

const DefaultErrorHandler = (error, reject) => {
  var str = ""
  if (error instanceof Error) {
    if (error.response) {
      if ([500].includes(error.response.status)) {
        str += "Erreur interne au serveur (error 500) \n"
      } else if ([404].includes(error.response.status))
        str += error.response.statusText + "\n"
      else {
        if (isString(error.response.data)) str += error.response.data + "\n"
        else if (isPlainObject(error.response.data))
          for (var el in error.response.data) {
            if (isPlainObject(error.response.data[el])) {
              str += Object.keys(error.response.data[el])
                .map(k => error.response.data[el][k])
                .join("\n")
            } else if (isArray(error.response.data[el]))
              str += error.response.data[el].join("\n")
            else str += error.response.data[el] + "\n"
            str += "\n"
          }
        else str += "Erreur du serveur"
      }
    } else str += error.message + "\n"
  } else if (typeof b == "string") {
    str += error + "\n"
  }
  store.commit("error", {
    msg: str,
    color: "error"
  })
  reject(error)
}
export { HTTP, DefaultErrorHandler, HMD_BACKEND_API_URL }
